import React, { PureComponent } from "react";
import _, { includes } from "lodash";
import $ from "jquery";
import "jquery-ui/themes/base/draggable.css";
import "jquery-ui/themes/base/resizable.css";
import "jquery-ui/ui/widgets/draggable";
import "jquery-ui/ui/widgets/resizable";
import {
  addFinSumParam,
  hasUrlParam,
  addParam,
  isThirdPartyTokenAuthorization,
  getRequestToken,
} from "../utils/general/general";
import { isIE } from "../utils/general/deviceInfoService";
import Loading from "../utils/animation/loading";
import commonStore from "../store/commonStore";
import CopyFigureUrlPopup from "../mainpage/copyFigureUrlPopup";

// Improtant!!! Don't change this component's code. Unless you have tested all compentent that use this compenent!

interface INormalScreenPopupProps {
  titleSource?: any;
  modalClass?: any;
  loadingOption: boolean;
  bodySource: any;
  openDetachURL?: string;
  modalWindowStyle?: any;
  modalBodyStyle?: any;
  // afterModalOpen means after modal opened, you can execute some js(like js function or jquery function)
  afterModalOpen?: any; // You can pass a array that contain function and it's parameter(example see drawingTemplate.tsx)
  customDetachURL?: string; // custom detachURL
  isIframeContent?: boolean; // iframe content
  iframeUrl?: string;
  useSameHeightAsModalWindow?: boolean;
  isBullBear?: boolean;
  showCopy?: boolean;
  anchorValue?: string;
}

interface INormalScreenPopupStates {
  modalWindowStyle: any;
  modalBodyStyle: any;
  showCopyFigurePopup: boolean;
}

class NormalScreenPopup extends PureComponent<
  INormalScreenPopupProps,
  INormalScreenPopupStates
> {
  public static defaultProps = {
    loadingOption: false,
  };

  public modalHeaderRef: any = React.createRef<HTMLDivElement>();
  public modalWindowRef: any = React.createRef<HTMLDivElement>();
  public modalBodyRef: any = React.createRef<HTMLDivElement>();
  public popupRef: React.RefObject<HTMLDivElement>; // Define popupRef

  public bodyObj: any = document.querySelector("body");

  constructor(props: INormalScreenPopupProps) {
    super(props);
    const _modalWindowStyle = {
      overflow: "hidden",
    };
    const _modalBodyStyle = {
      overflow: "auto",
      backgroundColor: "white",
      width: "100%",
      padding: 0,
    };
    if (!_.isEmpty(this.props.modalWindowStyle)) {
      Object.assign(_modalWindowStyle, this.props.modalWindowStyle);
    }
    if (!_.isEmpty(this.props.modalBodyStyle)) {
      Object.assign(_modalBodyStyle, this.props.modalBodyStyle);
    }
    this.state = {
      modalWindowStyle: _modalWindowStyle,
      modalBodyStyle: _modalBodyStyle,
      showCopyFigurePopup: false,
    };
    // Add a ref for the popup container
    this.popupRef = React.createRef();
  }

  handleMouseLeave = (e: React.MouseEvent) => {
    // Ensure e.relatedTarget is a valid Node before calling contains
    const relatedTarget = e?.relatedTarget as Node | null;

    // Check if the mouse is leaving the popup or the trigger element
    if (
      this.popupRef.current &&
      (relatedTarget instanceof Node) &&
      !this.popupRef.current?.contains(relatedTarget)
    ) {
      this.setState({ showCopyFigurePopup: false });
    }
  };

  handleClickOrMouseEnter = () => {
    this.setState({ showCopyFigurePopup: true });
  };

  public closeModal(event: any) {
    $("#modalClose").click();
    // Important!!! the close function can through bubbling propagation, So don't need write any code in here!
  }

  // TODO: More logic will add in future. must use window.HTML_RENDITION.openDetachURL in here!
  public openInNewWindow(event: any) {
    let openDetachURL = window.HTML_RENDITION.openDetachURL;

    let dataAttachedUrl = "";
    if (hasUrlParam(openDetachURL, "detachType") === "financialsContent") {
      dataAttachedUrl = addFinSumParam(openDetachURL);
    }
    if (hasUrlParam(openDetachURL, "detachType") === "figureGallery") {
      openDetachURL +=
        "&index=" +
        $(".carousel-item.fg.active>div").attr("data-fg-array-index");
    }

    if (
      hasUrlParam(openDetachURL, "detachType") === "figureGallery" ||
      hasUrlParam(openDetachURL, "detachType") === "embeddedVideo" ||
      hasUrlParam(openDetachURL, "detachType") === "gloablMarketData" ||
      hasUrlParam(openDetachURL, "detachType") === "pointKeyDataChanges" ||
      hasUrlParam(openDetachURL, "detachType") === "CommoditiesForecast" ||
      hasUrlParam(openDetachURL, "detachType") === "economicForecast" ||
      hasUrlParam(openDetachURL, "detachType") === "globalEconomicForecast" ||
      hasUrlParam(openDetachURL, "detachType") === "pointEconomicCalendar" ||
      hasUrlParam(openDetachURL, "detachType") === "pointEventCalendar" ||
      hasUrlParam(openDetachURL, "detachType") === "fxForecast" ||
      hasUrlParam(openDetachURL, "detachType") === "ratingBlockGroup"
    ) {
      dataAttachedUrl = openDetachURL;
    }

    let scrollbars = "no";
    if (hasUrlParam(dataAttachedUrl, "compName") === "FigureGallery") {
      const compId = hasUrlParam(dataAttachedUrl, "compId");
      if (!_.isUndefined(compId)) {
        scrollbars = Number(compId) === 11 ? "yes" : "no";
      }
    }

    const target = "_blank";
    const features =
      "directories=0,titlebar=0,toolbar=no,location=no,status=0,menubar=0,scrollbars=" +
      scrollbars +
      ",resizable=yes";
    if (this.props.customDetachURL) {
      dataAttachedUrl = this.props.customDetachURL;
    }
    if (isThirdPartyTokenAuthorization()) {
      getRequestToken().then((token: any) => {
        window.open(
          addParam(dataAttachedUrl, "__epftoken", token.access_token),
          target,
          features
        );
      });
    } else {
      window.open(dataAttachedUrl, target, features);
    }
  }

  public componentDidMount() {
    setTimeout(() => {
      if (_.isEmpty(this.modalHeaderRef.current)) {
        return null;
      }
      if (
        this.props.modalClass != "economic-forecast-modal" ||
        this.props.modalClass != "global-market-data-modal" ||
        this.props.modalClass != "global-economic-forecast-modal" ||
        this.props.modalClass != "point-economic-calendar-modal" ||
        this.props.modalClass != "commodities-forecast-modal" ||
        this.props.modalClass != "fx-forecast-modal" ||
        this.props.modalClass != "houseviews-modal" ||
        this.props.modalClass != "point-event-calendar-modal"
      ) {
        this.modalResizable();
      }

      if (this.props.isBullBear) {
        $(this.modalWindowRef.current)?.resizable?.({
          handles: "n, e, s, w, ne, se, sw, nw",
          minWidth: 500,
          maxWidth: 1280,
          minHeight: 300,
          maxHeight: 1000,
          containment: "#modal-root",
        });

        $(this.modalWindowRef.current)?.draggable?.({
          cancel: "div.modal-body",
          iframeFix: this.props.isIframeContent,
          containment: "window",
        });
      } else {
        $(this.modalWindowRef.current)?.draggable?.({
          cancel: "div.modal-body ",
          iframeFix: this.props.isIframeContent,
        });
      }

      ((executeFun: any) => {
        if (!executeFun) return;
        if (typeof executeFun[0] === "function") {
          const funPara = executeFun.slice(1);
          return executeFun[0](...funPara);
        }
      })(this.props.afterModalOpen);
    }, 200);

    if (
      this.props.modalClass == "economic-forecast-modal" ||
      this.props.modalClass == "global-market-data-modal" ||
      this.props.modalClass == "global-economic-forecast-modal" ||
      this.props.modalClass == "key-data-changes-modal" ||
      this.props.modalClass == "point-economic-calendar-modal" ||
      this.props.modalClass == "commodities-forecast-modal" ||
      this.props.modalClass == "fx-forecast-modal" ||
      this.props.modalClass == "houseviews-modal" ||
      this.props.modalClass == "point-event-calendar-modal"
    ) {
      setTimeout(() => {
        this.resizeForRHSModal(this.props.modalClass);
      });
    } else {
      window.addEventListener(
        "resize",
        _.throttle(_.bind(this.modalResizable, this), 200)
      );
    }
  }

  public modalResizable() {
    this.responsiveModal();
  }

  public responsiveModal() {
    // let modalWidth = 0;
    const windowWidth: number = ($(window) as any).width();
    const windowHeight: number = ($(window) as any).height();

    if (!this.modalWindowRef?.current) {
      return;
    }

    // if (this.state.modalWindowStyle.width) {
    //     modalWidth = parseFloat(this.state.modalWindowStyle.width);
    // }
    if ($("#modal-root>div").hasClass("modal-rating")) {
      $(".modal-rating .modal-body>div").height("auto");
      $(".rating_block_group_inpopup button.table_hidden_button").prop(
        "hidden",
        true
      );
    }

    if (
      $("#modal-root>div").hasClass("modal-rating") ||
      $("#modal-root>div").hasClass("modal-bullbear") ||
      $("#modal-root>div").hasClass("modal-catalyst") ||
      $("#modal-root>div").hasClass("modal-quant") ||
      $("#modal-root>div").hasClass("modal-print") ||
      $("#modal-root>div").hasClass("modal-esgMateriality") ||
      $("#modal-root>div").hasClass("modal-iframe") ||
      $("#modal-root>div").hasClass("modal-blog-copy-url") ||
      $("#modal-root>div").hasClass("modal-financials")
    ) {
      // for BB & CW & quant & finsum in RHS, print in LHS, rating-blocks in content body
      this.resizeForModal(windowWidth, windowHeight);
    }

    if ($("#modal-root>div").hasClass("modal-gallery")) {
      // for FG
      this.resizeForFG(windowWidth, windowHeight);
    }
  }

  public resizeForModal(windowWidth: number, windowHeight: number) {
    if (this.props.modalClass == "copy-url-modal") {
      windowWidth < 600
        ? (this.modalWindowRef.current.style.width = "inherit")
        : (this.modalWindowRef.current.style.width = 600 + "px");
      return;
    }

    if (windowWidth < 1000) {
      if (this.props.isBullBear) {
        if (windowWidth < 600) {
          this.modalWindowRef.current.style.width = windowWidth - 10 + "px";
        } else if (windowWidth < 800) {
          this.modalWindowRef.current.style.width = windowWidth - 60 + "px";
        } else {
          this.modalWindowRef.current.style.width = windowWidth - 100 + "px";
        }
        this.modalWindowRef.current.style.height =
          Math.min(windowHeight - 70, 950) + "px";
      } else {
        this.modalWindowRef.current.style.width = windowWidth - 10 + "px";
        this.modalWindowRef.current.style.height = windowHeight - 70 + "px";
      }
      this.modalWindowRef.current.style.left = 10 + "px";
      this.modalWindowRef.current.style.top = 50 + "px";
      this.modalWindowRef.current.style.bottom = 20 + "px";
      this.modalWindowRef.current.style.zIndex = 1050;
      this.modalWindowRef.current.style.position = "fixed";
    } else {
      if (!_.isEmpty(this.props.iframeUrl)) {
        if (this.props.isBullBear) {
          this.modalWindowRef.current.style.width = "768px";
          this.modalWindowRef.current.style.height =
            this.props.useSameHeightAsModalWindow &&
            !_.isEmpty(this.state.modalWindowStyle.height)
              ? this.state.modalWindowStyle.height
              : Math.min(windowHeight - 200, 950) + "px";
        } else {
          this.modalWindowRef.current.style.width = windowWidth - 100 + "px";
          this.modalWindowRef.current.style.height =
            this.props.useSameHeightAsModalWindow &&
            !_.isEmpty(this.state.modalWindowStyle.height)
              ? this.state.modalWindowStyle.height
              : windowHeight - 200 + "px";
        }
      } else {
        this.modalWindowRef.current.style.width = this.state.modalWindowStyle.width;
        this.modalWindowRef.current.style.height =
          windowHeight - 20 <=
          (parseFloat(this.state.modalWindowStyle.height) || 0)
            ? windowHeight - 20 + "px"
            : parseFloat(this.state.modalWindowStyle.height) + "px";
      }
      this.modalWindowRef.current.style.position = "relative";
      this.modalWindowRef.current.style.top = 0;
      this.modalWindowRef.current.style.bottom = 0;
    }
    if (this.props.isBullBear) {
      this.modalWindowRef.current.style.position = "fixed";
      this.modalBodyRef.current.style.setProperty(
        "padding-bottom",
        "0px",
        "important"
      );
      //adjusting the the top left corner of the modal window so that the popup is centered on the screen
      this.modalWindowRef.current.style.top = `${(window.innerHeight -
        parseInt(this.modalWindowRef.current.style.height, 10)) /
        2}px`;
      this.modalWindowRef.current.style.left = `${(window.innerWidth -
        parseInt(this.modalWindowRef.current.style.width, 10)) /
        2}px`;
    }
    const modalHeaderHeight = $(".modal-header").outerHeight() || 0;
    this.modalBodyRef.current.style.height =
      parseFloat(this.modalWindowRef.current.style.height) -
      modalHeaderHeight +
      "px";
  }

  public resizeForRHSModal(modalClass: any) {
    const that = this;
    const resizeModalFn = function() {
      const $modal = $("." + modalClass + " .rendition-modal-window");
      const windowWidth = $(window).width();
      const windowHeight = $(window).height();

      if (windowWidth && windowHeight) {
        if (windowWidth < 750) {
          $modal.css({
            width: windowWidth - 30 + "px",
            height: windowHeight - 70 + "px",
            left: "10px",
            right: "20px",
            top: "50px",
            bottom: "20px",
            zIndex: 1050,
            maxHeight: windowHeight - 70 + "px",
            position: "fixed",
          });
        } else {
          const mainPageWidth: number = $("#mainDiv").width() || 0;
          const previousModalHeight = $modal.height() || 650;

          $modal.css({
            width: mainPageWidth - 45 + "px",
            height: windowHeight - 105 + "px",
            left: windowWidth < 1000 ? 0 : that.state.modalWindowStyle.left,
            top: 0,
            bottom: 0,
            position: "relative",
            marginTop: that.state.modalWindowStyle.marginTop,
          });
          $modal
            .find(".economic-table-data .ReactTable .rt-table")
            .css("height", previousModalHeight - 200 - 10);
        }
      }
    };
    $(window).resize(resizeModalFn);
    resizeModalFn();
  }

  public resizeForFG(windowWidth: number, windowHeight: number) {
    if (windowWidth < 750) {
      this.modalWindowRef.current.style.width = windowWidth + "px";
      this.modalWindowRef.current.style.height = windowHeight - 85 + "px";
      $(this.modalWindowRef.current).addClass("smaller-figure-gallery");
    } else {
      const mainPageWidth: number = $("#mainPage").width() || 0;
      this.modalWindowRef.current.style.width = mainPageWidth - 45 + "px";
      this.modalWindowRef.current.style.height = windowHeight - 105 + "px";
      this.modalWindowRef.current.style.left =
        windowWidth < 1000 ? 0 : this.state.modalWindowStyle.left;
      this.modalWindowRef.current.style.marginTop = this.state.modalWindowStyle.marginTop;
      $(this.modalWindowRef.current).removeClass("smaller-figure-gallery");
    }
    this.modalBodyRef.current.style.height =
      parseFloat(this.modalWindowRef.current.style.height) - 27 + "px";
  }

  public componentWillUnmount() {
    window.HTML_RENDITION.openDetachURL = null;
    window.removeEventListener(
      "resize",
      _.throttle(_.bind(this.responsiveModal, this), 200)
    );
  }

  public fireModalClosure(event: any) {
    $("#modalClose").click();
  }

  public enterPressedCloseModal(event: any) {
    const key = event.keyCode || event.which;
    if (key === 13 || key === 32) {
      $("#modalClose").click();
    }
  }

  public enterPressedOpenInNewWindow(event: any) {
    const key = event.keyCode || event.which;
    if (key === 13 || key === 32) {
      this.openInNewWindow(event);
    }
  }

  public render() {
    const { titleSource, bodySource, modalClass } = this.props;
    // The loading animation is added for print popup.
    const zIndexValue = isIE() ? 0 : 2;
    const css = {
      zIndex: zIndexValue,
      height: "100%",
      width: "100%",
      position: "absolute",
    } as React.CSSProperties;
    const loadingZIndexCSS = this.props.loadingOption
      ? css
      : { height: "100%" };
    const openNewWindowTxt = "Open " + titleSource + " in a new window";
    const copyText = "Copy Figure from Figure Gallery";
    const docHeaderSectionJson = commonStore.getState().asyncStateReducer
      .docHeaderJsonData;
    const copyTextValue = docHeaderSectionJson?.i18n?.copyFigureTooltip;
    const copiedTextValue =
      docHeaderSectionJson?.i18n?.figureCopiedConfirmationTooltip;
    const excludeCopyFigurePlatformIdData = commonStore.getState()
      .asyncStateReducer.excludeCopyFigurePlatformIdData;

    return (
      <React.Fragment>
        <div
          role="dialog"
          aria-modal="true"
          tabIndex={-1}
          aria-label={titleSource}
          className={
            modalClass
              ? "modalWindow modal-fullscreen " + modalClass
              : "modalWindow modal-fullscreen"
          }
        >
          <div
            className={`rendition-modal-window ${
              this.props.isBullBear ? "bull-bear-modal" : ""
            }`}
            tabIndex={0}
            ref={this.modalWindowRef}
            style={this.state.modalWindowStyle}
          >
            <div
              className="modal-header no-select"
              style={{ cursor: "move", display: "block" }}
              ref={this.modalHeaderRef}
            >
              <h6 className="header-title">{titleSource}</h6>
              <div className="model-btn-container">
                {!includes(
                  excludeCopyFigurePlatformIdData,
                  window.HTML_RENDITION.initialData.platform
                ) &&
                  this.props.showCopy && (
                    <span
                      className="detach"
                      tabIndex={0}
                      role="button"
                      aria-label={copyText}
                      onMouseEnter={this.handleClickOrMouseEnter}
                      onMouseLeave={this.handleMouseLeave}
                      onClick={this.handleClickOrMouseEnter}
                      title={copyTextValue}
                    >
                      <span
                        className="copy-icon-image"
                        role="img"
                        // onMouseEnter={this.handleClickOrMouseEnter}
                        // onMouseLeave={this.handleMouseLeave}
                      ></span>
                    </span>
                  )}
                {!(
                  !includes(
                    excludeCopyFigurePlatformIdData,
                    window.HTML_RENDITION.initialData.platform
                  ) && this.props.showCopy
                ) &&
                  this.props.openDetachURL &&
                  !this.props.iframeUrl && (
                    <span
                      className="detach"
                      onClick={(e) => this.openInNewWindow(e)}
                      onKeyPress={(e) => this.enterPressedOpenInNewWindow(e)}
                    >
                      <span
                        tabIndex={0}
                        role="button"
                        aria-label={openNewWindowTxt}
                        className="icon-sprite icon-detach"
                      ></span>
                    </span>
                  )}
                <span
                  id="modalClose"
                  onKeyPress={(e: any) => this.enterPressedCloseModal(e)}
                  onClick={(e) => this.closeModal(e)}
                  aria-label="Close Dialog"
                  tabIndex={0}
                  className="modal-icon-close"
                  role="button"
                ></span>
                <span style={{ clear: "both" }}></span>
              </div>
            </div>
            {this.state.showCopyFigurePopup && (
              <div
                ref={this.popupRef} // Attach the ref to the popup container
                onMouseEnter={this.handleClickOrMouseEnter} // Keep popup visible on hover
                onMouseLeave={this.handleMouseLeave} // Hide popup when mouse leaves
              >
                <CopyFigureUrlPopup anchorValue={this.props.anchorValue} />
              </div>
            )}
            <div
              className="modal-body modal-body-height"
              ref={this.modalBodyRef}
              style={this.state.modalBodyStyle}
            >
              {!this.props.iframeUrl && (
                <div style={loadingZIndexCSS} className="modal-body-inner">
                  {typeof this.props.bodySource === "string" && (
                    <div dangerouslySetInnerHTML={{ __html: bodySource }} />
                  )}
                  {typeof this.props.bodySource === "object" && bodySource}
                </div>
              )}
              {this.props.iframeUrl && (
                <div>
                  <iframe
                    width={this.state.modalWindowStyle.width}
                    height={this.state.modalWindowStyle.height}
                    frameBorder="0"
                    src={this.props.iframeUrl}
                  />
                  {this.props.iframeUrl.includes("financials") && (
                    <div
                      id="viewFinancialsDefinitions"
                      style={{
                        position: "absolute",
                        bottom: "0px",
                        color: "#255BE3",
                        cursor: "pointer",
                        padding: "0px 0px 5px 20px",
                        fontFamily: "Citi-Sans-Text-Bold",
                      }}
                    >
                      View Financials Definitions
                    </div>
                  )}
                </div>
              )}
              {this.props.loadingOption && (
                <Loading scale={0.7} overrideStyle={{ zIndex: 1 }} />
              )}
            </div>
          </div>
        </div>
        <div
          className="modal-backdrop in"
          onClick={(e) => this.fireModalClosure(e)}
          style={{ zIndex: -1 }}
        ></div>
      </React.Fragment>
    );
  }
}

export default NormalScreenPopup;
